module.exports = __webpack_public_path__ + "static/media/visa.8f940450.png";